import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-auth-loading',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="auth-loading-overlay" *ngIf="isLoading">
      <div class="auth-loading-content">
        <div class="spinner"></div>
        <h2>{{ title }}</h2>
        <p>{{ message }}</p>
      </div>
    </div>
  `,
  styles: [`
    .auth-loading-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
    }

    .auth-loading-content {
      text-align: center;
      color: #ffffff;
    }

    .spinner {
      width: 60px;
      height: 60px;
      border: 4px solid rgba(255, 255, 255, 0.2);
      border-top: 4px solid #e94560;
      border-radius: 50%;
      animation: spin 1s linear infinite;
      margin: 0 auto 24px;
    }

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    h2 {
      font-size: 24px;
      font-weight: 500;
      margin: 0 0 12px;
      color: #ffffff;
    }

    p {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.7);
      margin: 0;
    }

    :host-context(.dark) .auth-loading-overlay {
      background: linear-gradient(135deg, #0d0d0d 0%, #1a1a1a 50%, #2d2d2d 100%);
    }
  `]
})
export class AuthLoadingComponent {
  @Input() isLoading = true;
  @Input() title = 'Authenticating';
  @Input() message = 'Please wait while we verify your credentials...';
}
